import { UseCase } from '@/core/base/use-case';
import { LandingRewardsResponse } from '../models/landing-rewards.model';
import { LandingRewardsRepository } from '../repositories/landing-rewards.repository';
import { Observable } from 'rxjs';

export class GetLandingRewardsUseCase
    implements UseCase<string, LandingRewardsResponse>
{
    constructor(private readonly repository: LandingRewardsRepository) {}

    execute(): Observable<LandingRewardsResponse> {
        return this.repository.getLandingRewards();
    }
}
